import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate } from 'react-router-dom';
import { useAuthStore } from './auth.store';
/**
 * Route-level permission guard. Redirects to /unauthorized when the current user
 * lacks the required permission(s). Super admins always pass.
 *
 * @example
 * { path: 'playground', element: <RequirePermission permission={PERMISSIONS.PLAYGROUND_ACCESS}><AIPlayground /></RequirePermission> }
 */
export default function RequirePermission({ permission, requireAll = false, children }) {
    const user = useAuthStore((s) => s.user);
    if (!user)
        return _jsx(Navigate, { to: "/login", replace: true });
    if (user.isSuperAdmin)
        return _jsx(_Fragment, { children: children });
    const codes = Array.isArray(permission) ? permission : [permission];
    const allowed = requireAll
        ? codes.every((c) => user.permissions.includes(c))
        : codes.some((c) => user.permissions.includes(c));
    return allowed ? _jsx(_Fragment, { children: children }) : _jsx(Navigate, { to: "/unauthorized", replace: true });
}
